{
  "version": 1,
  "asset_id": "951dd70f-1973-498d-b3a1-2face1204d9d",
  "project_id": "7580f3ab-e7a4-418d-abe6-5eb616986e51",
  "url": "/__l5e/assets-v1/951dd70f-1973-498d-b3a1-2face1204d9d/lecanto-black-shingle-roof-1200w.avif",
  "r2_key": "a/v1/7580f3ab-e7a4-418d-abe6-5eb616986e51/951dd70f-1973-498d-b3a1-2face1204d9d/lecanto-black-shingle-roof-1200w.avif",
  "original_filename": "lecanto-black-shingle-roof-1200w.avif",
  "size": 172946,
  "content_type": "image/avif",
  "created_at": "2026-07-21T19:37:41Z"
}
